import React from 'react';

function CardContentBody({ headingTag, title, meta, rows, children }) {
  const HeadingTag = headingTag || 'div';

  return (
    <div className={'content__body'}>
      {title && <HeadingTag className="body__title">{title}</HeadingTag>}
      {meta}
      {rows}
      <div className="body__body">{children}</div>
    </div>
  );
}

export default CardContentBody;
